import React from "react";
import { UserListEmptyStateTemplate } from "themes/administration/user/components";

const UserListEmptyState = (props) => {
    return <UserListEmptyStateTemplate {...props} />;
};

export default UserListEmptyState;
